const DESC_ORDER = 'desc';
const ASC_ORDER = 'asc';

function desc(a, b, getValue) {
  const va = getValue(a);
  const vb = getValue(b);
  if ((va === undefined) || (va === null)) {
    return (vb === undefined) || (vb === null) ? 0 : 1;
  }
  if ((vb === undefined) || (vb === null)) {
    return -1;
  }
  if (vb > va) return 1;
  return va === vb ? 0 : -1;
}

const stableSort = (array, cmp) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
};

const getSorting = (order, orderBy) => {
  const getValue = typeof orderBy === 'string' ? o => o[orderBy] : o => orderBy(o);
  return order === DESC_ORDER ? (a, b) => desc(a, b, getValue) : (a, b) => -desc(a, b, getValue);
};

export { stableSort, getSorting, ASC_ORDER, DESC_ORDER };
